require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-programme-manager-uk.json") })
        }
      }, "path---careers-programme-manager-uk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-programme-manager-uk!./.cache/json/careers-programme-manager-uk.json
// module id = 872
// module chunks = 231608221292675